import { render, staticRenderFns } from "./ChatCustom.vue?vue&type=template&id=20378e38&"
import script from "./ChatCustom.vue?vue&type=script&lang=js&"
export * from "./ChatCustom.vue?vue&type=script&lang=js&"
import style0 from "./ChatCustom.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports